import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { GridFilterModel, GridSortModel } from '@mui/x-data-grid-pro';

export interface RevisionFilter {
  showOnlyMine: boolean;
  showOnlyMe: boolean;
  showCompleted: boolean;
  filterModel: GridFilterModel;
  sortModel: GridSortModel;
}

const initialState: RevisionFilter = {
  showOnlyMine: false,
  showOnlyMe: false,
  showCompleted: false,
  filterModel: {
    items: [{ id: 'completedAtDefault', field: 'completedAt', operator: 'isEmpty' }],
  },
  sortModel: [
    {
      field: 'createdAt',
      sort: 'asc',
    },
  ],
};

export const revisionFilterSlice = createSlice({
  name: 'revisionFilter',
  initialState,
  reducers: {
    showOnlyMine: (state, action: PayloadAction<boolean>) => {
      state.showOnlyMine = action.payload;
    },
    showOnlyMe: (state, action: PayloadAction<boolean>) => {
      state.showOnlyMe = action.payload;
    },
    showCompleted: (state, action: PayloadAction<boolean>) => {
      state.showCompleted = action.payload;
    },
    setFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.filterModel = action.payload;
    },
    setSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.sortModel = action.payload;
    },
  },
});

export const { showOnlyMine, showOnlyMe, showCompleted, setFilterModel, setSortModel } = revisionFilterSlice.actions;

export const selectRevisionFilter = (state: RootState) => state.revisionFilter;

export default revisionFilterSlice.reducer;
